import React, { MouseEvent } from "react";

import { makeStyles, createStyles } from "@material-ui/core/styles";
import MuiIconButton from "@material-ui/core/IconButton";

import IconFirstPage from "@material-ui/icons/FirstPage";
import IconKeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import IconKeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import IconLastPage from "@material-ui/icons/LastPage";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexShrink: 0
    }
  })
);

interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: MouseEvent<HTMLButtonElement>, newPage: number) => void;
}

export const TablePagination = (props: TablePaginationActionsProps) => {
  const { count, page, rowsPerPage, onPageChange } = props;
  const classes = useStyles();

  const handleFirstPageButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <MuiIconButton onClick={handleFirstPageButtonClick} disabled={page === 0}>
        <IconFirstPage />
      </MuiIconButton>
      <MuiIconButton onClick={handleBackButtonClick} disabled={page === 0}>
        <IconKeyboardArrowLeft />
      </MuiIconButton>
      <MuiIconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
      >
        <IconKeyboardArrowRight />
      </MuiIconButton>
      <MuiIconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
      >
        <IconLastPage />
      </MuiIconButton>
    </div>
  );
};
